import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IAddDeviceRequest, IAxiosRetryConfig, IDeviceData } from '../../entity/interface/iDevices';
import { IAddDeviceUseCase } from '../../core/usecases/Device/AddDeviceUseCase';
import { IDeleteDeviceUseCase } from '../../core/usecases/Device/DeleteDeviceUseCase';
import { IGetDevicesUseCase } from '../../core/usecases/Device/GetDeviceUseCase';
export interface IDeviceService {
    addDevice(
        username: string,
        apiKey: string,
        payload: IAddDeviceRequest,
        token: string,
        identityToken: string,
        axiosRetryConfig: IAxiosRetryConfig
    ): Promise<IDeviceData | false>;
    deleteDevice(
        username: string,
        apiKey: string,
        guid: string,
        token: string,
        identityToken: string
    ): Promise<boolean>;
    getDevices(
        username: string,
        apiKey: string,
        token: string,
        identityToken: string,
        uid?: string | undefined,
        guid?: string | undefined
    ): Promise<IDeviceData[]>;
}

export class DeviceService implements IDeviceService {
    // Lazy getters for use cases to avoid circular dependencies
    private get addDeviceUseCase(): IAddDeviceUseCase {
        return container.resolve<IAddDeviceUseCase>(DI.USECASES.IAddDeviceUseCase);
    }

    private get deleteDeviceUseCase(): IDeleteDeviceUseCase {
        return container.resolve<IDeleteDeviceUseCase>(DI.USECASES.IDeleteDeviceUseCase);
    }

    private get getDevicesUseCase(): IGetDevicesUseCase {
        return container.resolve<IGetDevicesUseCase>(DI.USECASES.IGetDevicesUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async addDevice(
        username: string,
        apiKey: string,
        payload: IAddDeviceRequest,
        token: string,
        identityToken: string,
        axiosRetryConfig: IAxiosRetryConfig
    ): Promise<IDeviceData | false> {
        const response = await this.addDeviceUseCase.execute(
            username,
            apiKey,
            payload,
            token,
            identityToken,
            axiosRetryConfig
        );
        return response;
    }

    async deleteDevice(
        username: string,
        apiKey: string,
        guid: string,
        token: string,
        identityToken: string
    ): Promise<boolean | any> {
        const response = await this.deleteDeviceUseCase.execute(username, apiKey, guid, token, identityToken);
        return response;
    }

    async getDevices(
        username: string,
        apiKey: string,
        token: string,
        identityToken: string,
        uid?: string | undefined,
        guid?: string | undefined
    ): Promise<IDeviceData[] | any> {
        const response = await this.getDevicesUseCase.execute(username, apiKey, token, identityToken, uid, guid);
        return response;
    }
}
